import axios from "axios";

export const api = axios.create({
    baseURL: "https://email.3plheroes.com/api"
});
